import { Button } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import DownloadIcon from "@icons/myicons/document-file-download.svg?react";
import { createObjectUrl, downloadFile } from "@helpers/files";
import { useAssetClassFilter } from "./assetClassFilter";
import {
  useDownloadBookingsCsv,
  useDownloadInvestmentsCsv,
} from "./useCsvDownloads";

export const ExportButton = ({
  activeTab,
  params,
  compact,
  currency,
}: {
  activeTab?: string;
  // The short label fits the header line above the phone lists.
  compact?: boolean;
  currency?: string;
  params: {
    accountId: number[];
    minDate: string;
    maxDate: string;
    includeHistoric: boolean;
  };
}) => {
  const { t } = useTranslation();
  const { accountId, minDate, maxDate, includeHistoric } = params;
  // The export holds what the page shows, so it follows the asset class filter.
  const { investmentTypes } = useAssetClassFilter();
  const types = investmentTypes.length ? investmentTypes : undefined;

  const { mutate: downloadBookings } = useDownloadBookingsCsv(
    {
      accountId,
      investmentType: types,
      minDate,
      maxDate,
      displayCurrency: currency,
    },
    {
      onSuccess: (data) => {
        const url = createObjectUrl(data, "text/csv");
        downloadFile(url, "buchungen.csv");
      },
    }
  );
  const { mutate: downloadInvestments } = useDownloadInvestmentsCsv(
    {
      includeHistoric,
      accountId,
      type: types,
      displayCurrency: currency,
    },
    {
      onSuccess: (data) => {
        const url = createObjectUrl(data, "text/csv");
        downloadFile(url, "investments.csv");
      },
    }
  );

  const label = t("components.depotsStatistic.tabs.export");
  const handleClick = () =>
    activeTab === "bookings"
      ? downloadBookings(undefined)
      : downloadInvestments(undefined);

  return (
    <Button
      size="small"
      variant="outlined"
      startIcon={<DownloadIcon width="20px" height="20px" />}
      aria-label={compact ? label : undefined}
      onClick={handleClick}
    >
      {compact ? t("components.depotsStatistic.tabs.exportShort") : label}
    </Button>
  );
};
